@if (order) {
    <mat-horizontal-stepper
        #stepper
        [ngStyle]="{'background-color': '#E8E8E8'}"
        [selectedIndex]="step"
        linear
    >
        <mat-step [completed]="step === 1" [editable]="step === 0">
            <ng-template matStepLabel>Setup Mandate</ng-template>
            <create-mandate [order]="order"></create-mandate>
        </mat-step>
        <mat-step [completed]="step === 2" [editable]="step === 1">
            <ng-template matStepLabel>Setup Payment Plan</ng-template>
            <create-payment-plan [order]="order" [handleSuccess]="showStepThree"></create-payment-plan>
        </mat-step>
        <mat-step [completed]="paymentPlan !== undefined">
            <ng-template matStepLabel>Confirmation</ng-template>
            <payment-plan-confirmation [paymentPlan]="paymentPlan" [order]="order"></payment-plan-confirmation>
        </mat-step>
    </mat-horizontal-stepper>
}
